<p class="title">{{ 'PAYMENTS.PAYPAL.UNLINK.TITLE' | translate }}</p>
<p class="body">
  {{ 'PAYMENTS.PAYPAL.UNLINK.MESSAGE' | translate }}
</p>

<div class="buttons-row">
  <button i2gButton (click)="closeDialog(true)">
    {{ 'PAYMENTS.PAYPAL.UNLINK.ACTION.DISCONNECT' | translate }}
  </button>
  <button i2gButton buttonStyle="tertiary" (click)="closeDialog(false)">
    <span class="pull-left">
      {{ 'ACTION.CANCEL' | translate }}
    </span>
  </button>
</div>
